module.exports = __webpack_public_path__ + "img/decor-1.2a4ca229.svg";